import React, {  useEffect, useState } from 'react';
import Navigation from '../../../components/Navigation/Navigation';
import { ProSidebarProvider } from 'react-pro-sidebar';
import SidePanel from '../../../components/SidePanel/SidePanel';
import './Home.css';
import { Route, Redirect, Switch } from 'react-router-dom';
import Communication from '../Communication/Communication';
import Assessment from '../Assessment/Assessment';
import Training from '../Training/Training';
import User from '../User/User';
import { Util } from '../../../config/Util';
import axios from 'axios';
import { API } from '../../../config/API';
import Loader from '../../../components/Loader/Loader';
import Evaluation from '../Evaluation/Evaluation';
import Overview from '../Overview/Overview';
import Report from '../Report/Report';
import Submissions from '../../Common/Ibtikar/Submissions';
import Implementation from '../../Common/Ibtikar/Implementation';
import Facilitation from '../../Common/Ibtikar/Facilitation';
import Leader from '../../Common/Ibtikar/Leader';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const Home = () => {

  const [collapsed, setCollapsed] = useState(false);
  const [loader, setLoader] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const userId = Util.userId;
    if (Util.loginStatus && userId) {
      setLoader(true);
      axios.get(API.getUserDetail + userId).then((response) => {
        if (response.status === 200 && response.data.status === 'S') {
          console.log(response.data);
          Util.saveToSession("userData", response?.data);
          // notify other components that userData in session changed
          try {
            window.dispatchEvent(new Event('userDataUpdated'));
          } catch (e) {
            // noop for environments that don't support Window event dispatch
          }
          
          const usernameElement = document.getElementById("username");
          if (usernameElement) {
            usernameElement.innerHTML = "Welcome, " + Util.user;
          }
          history.push("/admin/overview");
        } else {
          console.error("Failed to fetch user data:", response.data.message);
          history.push("/landing");
        }
      }).catch(error => {
        console.error("Error fetching user data:", error);
        history.push("/landing");
      }).finally(() => {
        setLoader(false);
      });
    } else {
      history.push("/landing");
    }
  }, [history]);

  return (
    <React.Fragment>
      <Loader loading={loader} />
      <div className='admin_dashboard_wrapper'>
        <div className='navbar_wrapper'>
          <header className=''>
            <Navigation />
          </header>
        </div>
        <div className='home-content-wrapper'>
          <div className='overflow-auto side-bar-wrap'>
            <ProSidebarProvider>
              <SidePanel collapsed={collapsed} setCollapsed={setCollapsed} />
            </ProSidebarProvider>
          </div>
          <div className={`admin-content-section ${collapsed ? 'collapsed' : 'expanded'}`}>


            <Switch>
              <Route path="/admin/overview" >
                <Overview />
              </Route>
              <Route path="/admin/communication" >
                <Communication />
              </Route>
              <Route path="/admin/assessment" >
                <Assessment />
              </Route>
              <Route path="/admin/training" >
                <Training />
              </Route>
              <Route path="/admin/user" >
                <User />
              </Route>
              <Route path="/admin/report" >
                <Report />
              </Route>
              <Route path="/admin/evaluation" >
                <Evaluation />
              </Route>
              <Route path="/admin/ibtikar/submissions" >
                <Submissions />
              </Route>

              <Route path="/admin/ibtikar/implementation" >
                <Implementation />
              </Route>

              <Route path="/admin/ibtikar/facilitation" >
                <Facilitation />
              </Route>

              <Route path="/admin/ibtikar/leader-dashboard">
                <Leader/>
              </Route>
              <Route path="/admin/*" >
                <Redirect to='/landing' />
              </Route>
            </Switch>


          </div>
        </div>
      </div>
      {/* <div className='row footer-wrap'>
          <Footer/>
        </div> */}
    </React.Fragment>





  )
}

export default Home;